var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPaid)?_c('span',[_vm._v("Paid")]):_c('v-btn',{attrs:{"x-small":"","color":"error","outlined":"","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.pay.apply(null, arguments)}}},[_vm._v("Pay")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }